import { ChangeDetectionStrategy, Component, computed, input, ViewChild } from '@angular/core';

import { ButtonsModule } from '~ng-common-lib/ui/buttons';
import { FilledFlavor } from '~ng-common-lib/ui/buttons/filled-button.directive';
import {
	ClientReachMenuComponent,
	ClientReachMenuModule,
	openMenuWithResult,
} from '~ng-common-lib/ui/menu';

import { WarningTemplateComponent } from '../warning-template/warning-template.component';

export type WarningConfirmVariant = 'PRIMARY' | 'WARN' | 'WARNING';

@Component({
	selector: 'warning-modal',
	templateUrl: './warning-modal.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
	imports: [ClientReachMenuModule, WarningTemplateComponent, ButtonsModule],
})
export class WarningModalComponent {
	@ViewChild(ClientReachMenuComponent)
	private readonly menu?: ClientReachMenuComponent;

	public readonly $confirmText = input('', { alias: 'confirmText' });

	public readonly $cancelText = input('', { alias: 'cancelText' });

	public readonly $confirmVariant = input<WarningConfirmVariant>('WARN', {
		alias: 'confirmVariant',
	});

	public readonly $showCancel = input(true, { alias: 'showCancel' });

	private confirmed = false;

	protected readonly $mappedConfirmVariant = computed(() => {
		if (this.$confirmVariant() === 'PRIMARY') {
			return FilledFlavor.PRIMARY;
		}

		return FilledFlavor.WARNING;
	});

	public async open(): Promise<boolean> {
		this.confirmed = false;
		const openMenuWithBoolResult = openMenuWithResult;
		return await openMenuWithBoolResult(this.menu, () => this.confirmed);
	}

	public onConfirm(): void {
		this.confirmed = true;
		this.menu?.close();
	}

	public onCancel(): void {
		this.confirmed = false;
		this.menu?.close();
	}

	public close(): void {
		this.menu?.close();
	}
}
